import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const createQueryString = (name: string, value?: string | number | string[], append?: boolean) => {
        const params = new URLSearchParams(searchParams.toString());
        if (!value) {
            params.delete(name);
        } else if (append && !params.getAll(name).includes(value.toString())) {
            params.append(name, value.toString());
        } else {
            params.set(name, value.toString());
        }
        setSearchParams(params);
        window.history.replaceState({}, document.title, `${window.location.pathname}?${params.toString()}`);
    };

    return { searchParams, createQueryString };
};